/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function (root, doc) {
    'use strict';

    function liczba(el, fallback) {
        if (!el || String(el.value).trim() === '') return fallback;
        var value = Number(el.value);
        return Number.isInteger(value) ? value : fallback;
    }

    function lista(text, max) {
        var raw = String(text || '').trim();
        if (!raw) return [];
        var seen = Object.create(null), out = [];
        raw.split(/[\s,;]+/).forEach(function (part) {
            if (!/^\d+$/.test(part)) throw new Error('numbers');
            var n = Number(part);
            if (n < 1 || n > max || seen[n]) throw new Error('numbers');
            seen[n] = true;
            out.push(n);
        });
        return out.sort(function (a, b) { return a - b; });
    }

    function losowa(max) {
        if (root.crypto && typeof root.crypto.getRandomValues === 'function') {
            var limit = Math.floor(4294967296 / max) * max, buf = new Uint32Array(1), value;
            do { root.crypto.getRandomValues(buf); value = buf[0]; } while (value >= limit);
            return value % max;
        }
        return Math.floor(Math.random() * max);
    }

    function zestaw(n, k, wymagane, wykluczone) {
        var excluded = Object.create(null), chosen = Object.create(null), out = wymagane.slice();
        wykluczone.forEach(function (v) { excluded[v] = true; });
        wymagane.forEach(function (v) { chosen[v] = true; });
        while (out.length < k) {
            var value = losowa(n) + 1;
            if (!excluded[value] && !chosen[value]) { chosen[value] = true; out.push(value); }
        }
        return out.sort(function (a, b) { return a - b; });
    }

    function cechy(numbers) {
        var sum = 0, even = 0, run = numbers.length ? 1 : 0, maxRun = run, decades = Object.create(null), maxDecade = 0;
        numbers.forEach(function (n, i) {
            sum += n;
            if (n % 2 === 0) even++;
            if (i && n === numbers[i - 1] + 1) run++; else if (i) run = 1;
            if (run > maxRun) maxRun = run;
            var decade = Math.floor((n - 1) / 10);
            decades[decade] = (decades[decade] || 0) + 1;
            if (decades[decade] > maxDecade) maxDecade = decades[decade];
        });
        return { sum: sum, even: even, maxRun: maxRun, maxDecade: maxDecade };
    }

    function pasuje(features, filters) {
        return features.sum >= filters.sumMin && features.sum <= filters.sumMax &&
            features.even >= filters.evenMin && features.even <= filters.evenMax &&
            features.maxRun <= filters.maxRun && features.maxDecade <= filters.maxDecade;
    }

    function generuj(options) {
        var found = [], unique = Object.create(null), attempts = 0;
        while (found.length < options.count && attempts < options.maxAttempts) {
            attempts++;
            var numbers = zestaw(options.n, options.k, options.required, options.excluded);
            var key = numbers.join('-');
            if (unique[key]) continue;
            unique[key] = true;
            var features = cechy(numbers);
            if (pasuje(features, options)) found.push({ numbers: numbers, features: features });
        }
        return { rows: found, attempts: attempts };
    }

    root.PewniakiGeneratorFiltrow = { parseList: lista, features: cechy, matches: pasuje, generate: generuj };
    if (!doc) return;

    var box = doc.querySelector('[data-komb-filtry]');
    if (!box) return;
    var en = box.getAttribute('data-lang') === 'en', form = box.querySelector('[data-komb-filtry-form]');
    var game = box.querySelector('[data-komb-gra]'), nInput = box.querySelector('[data-komb-n]'), kInput = box.querySelector('[data-komb-k]');
    var status = box.querySelector('[data-komb-status]'), result = box.querySelector('[data-komb-wynik]'), tbody = box.querySelector('[data-komb-wiersze]');
    var csvButton = box.querySelector('[data-komb-csv]'), clearButton = box.querySelector('[data-komb-wyczysc]'), lastRows = [];

    function text(pl, eng) { return en ? eng : pl; }
    function updateLimits() {
        var k = liczba(kInput, 6);
        ['[data-komb-parz-min]', '[data-komb-parz-max]'].forEach(function (selector) { box.querySelector(selector).max = String(k); });
        box.querySelector('[data-komb-kolejne]').max = String(k);
        box.querySelector('[data-komb-dekada]').max = String(k);
    }
    game.addEventListener('change', function () {
        if (game.value !== 'custom') {
            var parts = game.value.split(','); nInput.value = parts[0]; kInput.value = parts[1];
            box.querySelector('[data-komb-parz-max]').value = parts[1];
            box.querySelector('[data-komb-kolejne]').value = parts[1];
            box.querySelector('[data-komb-dekada]').value = parts[1];
            updateLimits();
        }
    });
    kInput.addEventListener('change', updateLimits);

    function clear() { tbody.replaceChildren(); result.hidden = true; status.textContent = ''; lastRows = []; }
    clearButton.addEventListener('click', clear);

    form.addEventListener('submit', function (event) {
        event.preventDefault(); clear();
        try {
            var n = liczba(nInput, 0), k = liczba(kInput, 0), count = liczba(box.querySelector('[data-komb-ile]'), 25);
            if (n < 2 || n > 100 || k < 1 || k > Math.min(12, n)) throw new Error('range');
            var required = lista(box.querySelector('[data-komb-wymagane]').value, n);
            var excluded = lista(box.querySelector('[data-komb-wykluczone]').value, n);
            if (required.length > k || required.some(function (v) { return excluded.indexOf(v) >= 0; }) || n - excluded.length < k) throw new Error('conflict');
            var minPossible = k * (k + 1) / 2, maxPossible = k * (2 * n - k + 1) / 2;
            var options = {
                n: n, k: k, count: count, required: required, excluded: excluded, maxAttempts: 100000,
                sumMin: liczba(box.querySelector('[data-komb-suma-min]'), minPossible),
                sumMax: liczba(box.querySelector('[data-komb-suma-max]'), maxPossible),
                evenMin: liczba(box.querySelector('[data-komb-parz-min]'), 0),
                evenMax: liczba(box.querySelector('[data-komb-parz-max]'), k),
                maxRun: liczba(box.querySelector('[data-komb-kolejne]'), k),
                maxDecade: liczba(box.querySelector('[data-komb-dekada]'), k)
            };
            if (options.sumMin > options.sumMax || options.evenMin > options.evenMax || options.evenMax > k || options.maxRun < 1 || options.maxDecade < 1) throw new Error('filters');
            var output = generuj(options); lastRows = output.rows;
            output.rows.forEach(function (row, index) {
                var tr = doc.createElement('tr'), cells = [index + 1, row.numbers.join(', '), row.features.sum, row.features.even];
                cells.forEach(function (value, cellIndex) {
                    var cell = doc.createElement(cellIndex === 0 ? 'th' : 'td');
                    if (cellIndex === 0) cell.scope = 'row';
                    cell.textContent = String(value); tr.appendChild(cell);
                });
                tbody.appendChild(tr);
            });
            result.hidden = output.rows.length === 0;
            status.textContent = jst('combinations.result', [output.rows.length, count, output.attempts]);
            if (!output.rows.length) status.textContent += ' ' + jst("pages_generator_kombinacji_filtry_js.65bd60280667");
        } catch (error) {
            status.textContent = jst("pages_generator_kombinacji_filtry_js.0a4e3e2093c7");
        }
    });

    csvButton.addEventListener('click', function () {
        if (!lastRows.length) return;
        var lines = [jst("pages_generator_kombinacji_filtry_js.39d191af5eb1")];
        lastRows.forEach(function (row, index) { lines.push((index + 1) + ';"' + row.numbers.join(', ') + '";' + row.features.sum + ';' + row.features.even); });
        var blob = new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
        var link = doc.createElement('a'); link.href = URL.createObjectURL(blob); link.download = jst("pages_generator_kombinacji_filtry_js.be0c399c91d7");
        doc.body.appendChild(link); link.click(); link.remove(); setTimeout(function () { URL.revokeObjectURL(link.href); }, 0);
    });
    updateLimits();
}(typeof window !== 'undefined' ? window : globalThis, typeof document !== 'undefined' ? document : null));
